import React, { createContext, useState, useEffect, useContext } from 'react';
import type { Node } from 'react';
import { api } from '@vmos2/core';
import { useSettings } from './Settings';

export const PhonePrefixContext = createContext();

type ProviderProps = {
  children: Node,
};

export const PhonePrefixProvider = ({ children }: ProviderProps): Node => {
  const [phonePrefixData, setPhonePrefixData] = useState([]);
  const { phoneAllowedCountries } = useSettings();

  useEffect(() => {
    fetchPhonePrefixData();
  }, []);

  const fetchPhonePrefixData = () => api.get('/phonePrefixes.json', { baseURL: null }).then(setPhonePrefixData);

  const filteredPhonePrefixData = phoneAllowedCountries?.length
    ? phonePrefixData.filter(({ code }) => phoneAllowedCountries.includes(code))
    : phonePrefixData;

  return <PhonePrefixContext.Provider value={filteredPhonePrefixData}>{children}</PhonePrefixContext.Provider>;
};

export const usePhonePrefix = () => {
  return useContext(PhonePrefixContext);
};
